<template>
  <div :class="pillClass">
    <img class="homework-status-pill__icon" :src="pillIconSource" alt="" aria-hidden="true" />
    <span class="homework-status-pill__description">{{ description }}</span>
  </div>
</template>

<script>
export default {
  name: 'HomeworkStatusPill',
  props: {
    status: {
      type: String,
      default: 'not-checked',
      validator: value => ['partly-checked', 'checked', 'not-checked', 'unfinished'].includes(value),
    },
  },
  computed: {
    description() {
      switch (this.status) {
        case 'partly-checked':
          return 'Częściowo odrobiona';
        case 'checked':
          return 'Odrobiona';
        case 'unfinished':
          return 'Nieodrobiona';
        default:
          return 'Niesprawdzona';
      }
    },
    pillClass() {
      return `homework-status-pill homework-status-pill--${this.status}`;
    },
    pillIconSource() {
      switch (this.status) {
        case 'partly-checked':
          return require('@/assets/images/icons/i_homework-partly-checked.svg');
        case 'checked':
          return require('@/assets/images/icons/i_homework-checked.svg');
        case 'unfinished':
          return require('@/assets/images/icons/i_homework-unfinished.svg');
        default:
          return require('@/assets/images/icons/i_homework-not-checked.svg');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.homework-status-pill {
  display: flex;
  padding: 2px 12px 2px 8px;
  align-items: center;
  gap: 8px;
  border-radius: 16px;

  &--checked {
    background-color: var(--info-100, #E8F4FF);
    color: var(--info-900, #175CD3);
  }

  &--partly-checked {
    background-color: var(--info-100, #E8F4FF);
    color: var(--info-900, #175CD3);
  }

  &--not-checked {
    background-color: #F0F2F6;
    color: #5B657A;
  }

  &--unfinished {
    background-color: #FCE3F0;
    color: #E10A7B;
  }

  &__description {
    font-family: 'GT Walsheim Pro';
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    /* 133.333% */
  }
}
</style>
